var _circle, _rect, _rect2, _rect3, _g, _path, _path2, _path3, _path4, _path5, _path6, _rect4, _rect5, _rect6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOpenAccessCommunity = function SvgOpenAccessCommunity(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#F7F9FA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.608,
    y: 21.414,
    width: 12.922,
    height: 3.657,
    rx: 1.829,
    transform: "rotate(45 20.608 21.414)",
    fill: "#C9CED4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.871,
    y: 38.118,
    width: 9.389,
    height: 3.657,
    rx: 1.829,
    transform: "rotate(5.149 15.871 38.118)",
    fill: "#C9CED4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.395,
    y: 18.286,
    width: 9.269,
    height: 3.657,
    rx: 1.829,
    transform: "rotate(77.278 36.395 18.286)",
    fill: "#C9CED4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#openAccessCommunity_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.914 37.657a2 2 0 0 1 2-2h90.171a2 2 0 0 1 2 2v30.915h-94.17V37.657Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.914 68.572h94.171v54.685a2 2 0 0 1-2 2h-90.17a2 2 0 0 1-2-2V68.571Z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.17 97.185c0 2.468-1.938 4.468-4.328 4.468-2.39 0-4.328-2-4.328-4.468 0-2.467 1.938-4.467 4.328-4.467 2.39 0 4.328 2 4.328 4.467Z",
    fill: "#E6E9ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.842 102.93c-3.127 0-5.379 1.14-6.974 2.959-1.596 1.82-2.467 4.243-2.919 6.614h17.159c1.321 0 2.269-1.255 1.813-2.496-.533-1.454-1.283-3.18-2.105-4.118-1.595-1.819-3.848-2.959-6.974-2.959Z",
    fill: "#E6E9ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.82 97.185c0 2.468-1.937 4.468-4.328 4.468-2.39 0-4.328-2-4.328-4.468 0-2.467 1.938-4.467 4.328-4.467 2.39 0 4.328 2 4.328 4.467Z",
    fill: "#E6E9ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.492 102.93c-3.126 0-5.379 1.14-6.974 2.959-1.069 1.22-1.813 2.709-2.323 4.273-.39 1.193.567 2.341 1.822 2.341h17.368s-1.323-4.794-2.919-6.614c-1.595-1.819-3.847-2.959-6.974-2.959Z",
    fill: "#E6E9ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.04 93.479c0 3.152-2.49 5.707-5.564 5.707-3.073 0-5.564-2.555-5.564-5.707 0-3.152 2.491-5.707 5.564-5.707s5.565 2.555 5.565 5.707Z",
    fill: "#C9CED4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.476 100.454c-3.908 0-6.723 1.436-8.717 3.725-1.996 2.291-3.084 5.34-3.649 8.324h24.732s-1.653-6.033-3.648-8.324c-1.994-2.289-4.81-3.725-8.718-3.725Z",
    fill: "#C9CED4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 39.314,
    height: 3.657,
    rx: 1.829,
    transform: "matrix(1 0 0 -1 39.315 53.943)",
    fill: "#E6E9ED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 48.457,
    height: 3.657,
    rx: 1.829,
    transform: "matrix(1 0 0 -1 39.315 45.714)",
    fill: "#E6E9ED"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 21.943,
    height: 3.657,
    rx: 1.829,
    transform: "matrix(1 0 0 -1 39.315 62.171)",
    fill: "#C9CED4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "openAccessCommunity_svg__a",
    x: 22.914,
    y: 33.657,
    width: 114.172,
    height: 109.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    "in": "SourceAlpha",
    result: "effect1_dropShadow_1263_22328"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1263_22328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1263_22328",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOpenAccessCommunity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/openAccessCommunity.svg";